<template>
    <div class="app-form-multiple-select">
        <div class="label-container">
            <div class="label-text">{{ label }}</div>
            <div v-if="sublabel" class="sublabel-text">{{ sublabel }}</div>
        </div>
        <div class="select-container">
<!--            <div v-for="(item, index) in value">{{item}}</div>-->
            
            <Field
                v-slot="{ field, errors, meta }"
                :name="errorLabel || name || label"
                :rules="rules"
                :key="`${errorLabel || name || label}-${rules || 'none'}`"
                :model-value="inputValue && inputValue.length > 0 ? inputValue.join(',') : ''"
            >

<!--                Acts as a show input for validation purposes-->
                <input type="text" readonly="readonly" :value="inputValue" v-show="false">
<!--                <v-select-->
<!--                    :value="value"-->
<!--                    :items="items"-->
<!--                    required-->
<!--                    outlined-->
<!--                    multiple-->
<!--                    color="text"-->
<!--                    @change="updateSelect"-->
<!--                    :item-text="itemText"-->
<!--                    :item-value="itemValue"-->
<!--                    :menu-props="{ offsetY: true }"-->
<!--                    :error-messages="errors.length > 0 ? [''] : []"-->
<!--                >-->
<!--                    <template #selection="{item}">{{ item.name }}</template>-->
<!--                </v-select>-->
               


                <div v-if="errors" class="error--text text-caption">{{errors[0]}}</div>
<!--                <div class="error&#45;&#45;text text-caption">{{valid}}</div>-->
            </Field>
            <AppMultipleSelect
                :items="items"
                item-title="name"
                :item-value="itemValue"
                :value="inputValue"
                @input="updateSelect"
                :addButtonText="addButtonText"
                :draggable="draggable"
            ></AppMultipleSelect>
        </div>
    </div>
</template>

<script>
import { Field, Form, defineRule, configure } from 'vee-validate'
import { required } from '@vee-validate/rules'

configure({
    validateOnInput: true,
    validateOnChange: true,
    validateOnBlur: true,
    validateOnModelUpdate: true,
})

export default {
    name: "AppFormMultipleSelect",
    emits: ['input', 'update:modelValue'],
    components: {
        Field,
        Form
    },
    props: {
        value: {
            type: Array,
            default: () => []
        },
        modelValue: {
            type: Array,
            default: () => []
        },
        items: {
            required: true
        },
        errorLabel: {

        },
        rules: {

        },
        itemText: {
            required: false,
            type: String
        },
        itemValue: {
            required: false,
            type: String,
            default: 'id'
        },
        label: {
            type: String,
            required: true
        },
        sublabel: {
            type: String,
        },
        draggable: {
            type: Boolean
        },
        addButtonText: {
            type: String,
            default: "Add Group"
        },
        name: {

        }

    },
    computed: {
        inputValue() {
            return this.modelValue !== undefined && this.modelValue.length > 0 ? this.modelValue : (this.value || [])
        }
    },
    methods: {
        updateSelect(e) {
            this.$emit('input', e)
            this.$emit('update:modelValue', e)
        }
    }
}
</script>

<style scoped>
.app-form-multiple-select {
    display: flex;
    align-items: flex-start;
    margin-bottom: 16px;
}

.label-container {
    min-width: 120px;
    margin-right: 15px;
    color: #757575;
    padding-top: 8px;
}

.label-text {
    font-size: 14px;
    font-weight: 500;
}

.sublabel-text {
    font-size: 12px;
    color: #9e9e9e;
}

.select-container {
    flex: 1;
    max-height: 300px;
    overflow-y: auto;
}

.error--text {
    color: #ff5252;
    font-size: 12px;
}
</style>